module.exports = __webpack_public_path__ + "img/small-14.be15eca4.webp";